<mat-sidenav-container class="wf-sidenav-container tw-h-full tw-bg-gray-900" autosize>
  <mat-sidenav
    *ngIf="!authService.palModeValue"
    #sidenav="matSidenav"
    [mode]="isSmallScreen ? 'over' : 'side'"
    [opened]="thinSidenavOpened"
    [disableClose]="!isSmallScreen"
    position="start"
    class="my-sidenav-thin tw-bg-gray-950 tw-border-r tw-border-gray-700 tw-transition-all tw-duration-200"
    [ngClass]="railExpanded ? 'tw-w-52' : 'tw-w-12'">
    <div class="tw-flex tw-flex-col tw-h-full tw-bg-gray-950">
      <!-- Top section -->
      <div
        class="tw-flex tw-flex-col tw-gap-1.5 tw-flex-1 tw-pt-2 tw-px-1.5"
        [ngClass]="railExpanded ? 'tw-items-stretch' : 'tw-items-center'">
        <!-- Rail header: Live Data logo (expanded) + expand/collapse toggle -->
        <div
          class="tw-flex tw-items-center tw-mb-1"
          [ngClass]="railExpanded ? 'tw-justify-between' : 'tw-justify-center'">
          <img
            *ngIf="railExpanded"
            src="assets/img/logo-white.svg"
            alt="Live Data logo"
            class="tw-w-28 tw-ml-1.5" />
          <button
            class="tw-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-shrink-0 tw-rounded-lg tw-bg-transparent tw-border-0 tw-cursor-pointer hover:tw-bg-gray-800 tw-transition-colors"
            (click)="toggleRail()"
            [matTooltip]="railExpanded ? 'Collapse menu' : 'Expand menu'"
            matTooltipPosition="right">
            <!-- outlined panel glyph; the Material Icons font here only ships the
                 filled variant, which reads as heavy as the product icons -->
            <svg
              class="tw-w-[18px] tw-h-[18px] tw-text-gray-500"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true">
              <rect x="3" y="4" width="18" height="16" rx="2" />
              <path d="M9 4v16" />
            </svg>
          </button>
        </div>

        <button
          class="tw-flex tw-items-center tw-rounded-lg tw-border-0 tw-cursor-pointer hover:tw-bg-gray-800 tw-transition-colors"
          [ngClass]="[railBtnClass, rlaChat.isActive ? 'tw-bg-[#102825]' : 'tw-bg-transparent']"
          [routerLink]="'/chat'"
          routerLinkActive=""
          #rlaChat="routerLinkActive"
          matTooltip="Chat"
          [matTooltipDisabled]="railExpanded"
          matTooltipPosition="left"
          (click)="onNavButtonClick()">
          <mat-icon class="tw-text-[18px] tw-w-[18px] tw-h-[18px] tw-shrink-0" [ngClass]="rlaChat.isActive ? 'tw-text-[#7FFFD4]' : 'tw-text-gray-400'"
            >question_answer
          </mat-icon>
          <span *ngIf="railExpanded" class="tw-text-sm tw-whitespace-nowrap" [ngClass]="rlaChat.isActive ? 'tw-text-[#7FFFD4]' : 'tw-text-gray-300'">Chat</span>
        </button>

        <!-- History sub-item, shown only while Chat is the active section -->
        <button
          *ngIf="rlaChat.isActive"
          class="tw-flex tw-items-center tw-rounded-lg tw-bg-transparent tw-border-0 tw-cursor-pointer hover:tw-bg-gray-800 tw-transition-colors"
          [ngClass]="railExpanded ? 'tw-w-full tw-h-8 tw-justify-start tw-gap-3 tw-pl-8 tw-pr-2.5' : 'tw-w-7 tw-h-7 tw-justify-center'"
          matTooltip="History"
          [matTooltipDisabled]="railExpanded"
          matTooltipPosition="left"
          (click)="openChatHistory()">
          <mat-icon class="tw-text-[15px] tw-w-[15px] tw-h-[15px] tw-shrink-0 tw-text-gray-500 hover:tw-text-gray-300">
            history
          </mat-icon>
          <span *ngIf="railExpanded" class="tw-text-xs tw-text-gray-400 tw-whitespace-nowrap">History</span>
        </button>

        <!-- Settings sub-item (admins only), shown only while Chat is the active section.
             Its only setting is the LangGraph instance selector, which the service
             disables in production — so hide the whole item there too. -->
        <button
          *ngIf="rlaChat.isActive && ($showAdmin | async) && langGraphInstanceService.isEnabled"
          class="tw-flex tw-items-center tw-rounded-lg tw-bg-transparent tw-border-0 tw-cursor-pointer hover:tw-bg-gray-800 tw-transition-colors"
          [ngClass]="railExpanded ? 'tw-w-full tw-h-8 tw-justify-start tw-gap-3 tw-pl-8 tw-pr-2.5' : 'tw-w-7 tw-h-7 tw-justify-center'"
          matTooltip="Settings"
          [matTooltipDisabled]="railExpanded"
          matTooltipPosition="left"
          (click)="openChatSettings()">
          <mat-icon class="tw-text-[15px] tw-w-[15px] tw-h-[15px] tw-shrink-0 tw-text-gray-500 hover:tw-text-gray-300">
            construction
          </mat-icon>
          <span *ngIf="railExpanded" class="tw-text-xs tw-text-gray-400 tw-whitespace-nowrap">Settings</span>
        </button>

        <button
          class="tw-flex tw-items-center tw-rounded-lg tw-border-0 tw-cursor-pointer hover:tw-bg-gray-800 tw-transition-colors"
          [ngClass]="[railBtnClass, rlaInsights.isActive ? 'tw-bg-[#102825]' : 'tw-bg-transparent']"
          [routerLink]="'/insights'"
          routerLinkActive=""
          #rlaInsights="routerLinkActive"
          matTooltip="Companies"
          [matTooltipDisabled]="railExpanded"
          matTooltipPosition="left"
          (click)="onNavButtonClick()">
          <mat-icon class="tw-text-[18px] tw-w-[18px] tw-h-[18px] tw-shrink-0" [ngClass]="rlaInsights.isActive ? 'tw-text-[#7FFFD4]' : 'tw-text-gray-400'">
            business
          </mat-icon>
          <span *ngIf="railExpanded" class="tw-text-sm tw-whitespace-nowrap" [ngClass]="rlaInsights.isActive ? 'tw-text-[#7FFFD4]' : 'tw-text-gray-300'">Companies</span>
        </button>

        <button
          class="tw-flex tw-items-center tw-rounded-lg tw-border-0 tw-cursor-pointer hover:tw-bg-gray-800 tw-transition-colors"
          [ngClass]="[railBtnClass, rlaPeople.isActive ? 'tw-bg-[#102825]' : 'tw-bg-transparent']"
          routerLinkActive=""
          [routerLinkActiveOptions]="{ paths: 'subset', matrixParams: 'ignored', queryParams: 'ignored', fragment: 'ignored' }"
          #rlaPeople="routerLinkActive"
          [routerLink]="'/people'"
          matTooltip="People"
          [matTooltipDisabled]="railExpanded"
          matTooltipPosition="left"
          (click)="onNavButtonClick()">
          <mat-icon class="tw-text-[18px] tw-w-[18px] tw-h-[18px] tw-shrink-0" [ngClass]="rlaPeople.isActive ? 'tw-text-[#7FFFD4]' : 'tw-text-gray-400'">
            people
          </mat-icon>
          <span *ngIf="railExpanded" class="tw-text-sm tw-whitespace-nowrap" [ngClass]="rlaPeople.isActive ? 'tw-text-[#7FFFD4]' : 'tw-text-gray-300'">People</span>
        </button>

        <button
          *ngIf="(($orgCapabilities | async) || []).includes('ledger') && ($isOrgActive | async) && selectedOrg?.id"
          class="tw-flex tw-items-center tw-rounded-lg tw-border-0 tw-cursor-pointer hover:tw-bg-gray-800 tw-transition-colors"
          [ngClass]="[railBtnClass, rlaLedgers.isActive ? 'tw-bg-[#102825]' : 'tw-bg-transparent']"
          [routerLink]="'/' + selectedOrg?.id + '/ledgers'"
          routerLinkActive=""
          [routerLinkActiveOptions]="{ paths: 'subset', matrixParams: 'ignored', queryParams: 'ignored', fragment: 'ignored' }"
          #rlaLedgers="routerLinkActive"
          matTooltip="Ledgers"
          [matTooltipDisabled]="railExpanded"
          matTooltipPosition="left"
          (click)="onNavButtonClick()">
          <mat-icon class="tw-text-[18px] tw-w-[18px] tw-h-[18px] tw-shrink-0" [ngClass]="rlaLedgers.isActive ? 'tw-text-[#7FFFD4]' : 'tw-text-gray-400'">
            fact_check
          </mat-icon>
          <span *ngIf="railExpanded" class="tw-text-sm tw-whitespace-nowrap" [ngClass]="rlaLedgers.isActive ? 'tw-text-[#7FFFD4]' : 'tw-text-gray-300'">Ledgers</span>
        </button>

        <!-- Administration (internal users only) -->
        <button
          *ngIf="$showAdmin | async"
          class="tw-flex tw-items-center tw-rounded-lg tw-bg-transparent tw-border-0 tw-cursor-pointer hover:tw-bg-gray-800 tw-transition-colors"
          [ngClass]="railBtnClass"
          [matMenuTriggerFor]="adminMenu"
          matTooltip="Administration"
          [matTooltipDisabled]="railExpanded"
          matTooltipPosition="left">
          <mat-icon class="tw-text-[18px] tw-w-[18px] tw-h-[18px] tw-shrink-0 tw-text-gray-400">construction</mat-icon>
          <span *ngIf="railExpanded" class="tw-text-sm tw-text-gray-300 tw-whitespace-nowrap">Administration</span>
        </button>

        <!-- Quick Inspect: inline input under the admin entry when expanded -->
        <div *ngIf="railExpanded && ($showAdmin | async)" class="tw-px-2.5 tw-py-1">
          <div class="tw-flex tw-items-center tw-gap-1">
            <input
              type="text"
              [(ngModel)]="quickSearchValue"
              (keyup.enter)="quickSearch()"
              placeholder="Quick search..."
              class="tw-flex-1 tw-min-w-0 tw-bg-gray-800 tw-text-white tw-border tw-border-gray-600 tw-rounded tw-px-1.5 tw-py-0.5 tw-text-xs focus:tw-outline-none focus:tw-border-gray-400" />
            <button
              (click)="quickSearch()"
              class="tw-flex-shrink-0 tw-bg-gray-800 tw-text-gray-300 hover:tw-text-white tw-border tw-border-gray-600 hover:tw-border-gray-400 tw-rounded tw-p-0.5 tw-transition">
              <mat-icon class="tw-text-base tw-w-5 tw-h-5">search</mat-icon>
            </button>
          </div>
        </div>

        <!-- Quick Inspect: collapsed sub-icon opening a focused input popover -->
        <button
          *ngIf="!railExpanded && ($showAdmin | async)"
          class="tw-flex tw-items-center tw-justify-center tw-w-7 tw-h-7 tw-rounded-lg tw-bg-transparent tw-border-0 tw-cursor-pointer hover:tw-bg-gray-800 tw-transition-colors"
          [matMenuTriggerFor]="inspectMenu"
          #inspectTrigger="matMenuTrigger"
          (menuOpened)="focusInspectInput()"
          matTooltip="Quick Search"
          matTooltipPosition="left">
          <mat-icon class="tw-text-[15px] tw-w-[15px] tw-h-[15px] tw-shrink-0 tw-text-gray-500 hover:tw-text-gray-300">
            search
          </mat-icon>
        </button>
        <mat-menu
          #inspectMenu="matMenu"
          xPosition="after"
          class="tw-bg-gray-900 tw-rounded-xl tw-shadow-lg tw-py-1 tw-border tw-border-solid tw-border-gray-600">
          <div
            class="tw-px-3 tw-py-1"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()">
            <div class="tw-flex tw-items-center tw-gap-1">
              <input
                #inspectPopoverInput
                type="text"
                [(ngModel)]="quickSearchValue"
                (keyup.enter)="quickSearch()"
                placeholder="Quick search..."
                class="tw-w-52 tw-bg-gray-800 tw-text-white tw-border tw-border-gray-600 tw-rounded tw-px-1.5 tw-py-1 tw-text-xs focus:tw-outline-none focus:tw-border-gray-400" />
              <button
                (click)="quickSearch()"
                class="tw-flex-shrink-0 tw-bg-gray-800 tw-text-gray-300 hover:tw-text-white tw-border tw-border-gray-600 hover:tw-border-gray-400 tw-rounded tw-p-0.5 tw-transition">
                <mat-icon class="tw-text-base tw-w-5 tw-h-5">search</mat-icon>
              </button>
            </div>
          </div>
        </mat-menu>
        <mat-menu
          #adminMenu="matMenu"
          class="tw-bg-gray-900 tw-text-gray-100 tw-rounded-xl tw-shadow-lg tw-py-2 tw-border tw-border-solid tw-border-gray-600">
          <a
            mat-menu-item
            *ngFor="let item of adminRoutes"
            [routerLink]="item.path"
            (click)="onNavButtonClick()">
            {{item.name}}
          </a>
          <a mat-menu-item (click)="triggerRefresh()">Refresh Session</a>
        </mat-menu>
      </div>

      <!-- Bottom section -->
      <div
        class="tw-flex tw-flex-col tw-gap-2 tw-mt-auto tw-pb-4 tw-px-1.5"
        [ngClass]="railExpanded ? 'tw-items-stretch' : 'tw-items-center'">
        <!-- help icon  -->
        <button
          class="tw-flex tw-items-center tw-rounded-lg tw-bg-transparent tw-border-0 tw-cursor-pointer hover:tw-bg-gray-800 tw-transition-colors"
          [ngClass]="railBtnClass"
          (click)="showIntercom()"
          matTooltip="Get help"
          [matTooltipDisabled]="railExpanded"
          matTooltipPosition="left">
          <mat-icon class="tw-text-[18px] tw-w-[18px] tw-h-[18px] tw-shrink-0 tw-text-gray-800 dark:tw-text-gray-400">help_outline</mat-icon>
          <span *ngIf="railExpanded" class="tw-text-sm tw-text-gray-300 tw-whitespace-nowrap">Get Help</span>
        </button>

        <!-- account menu -->
        <button
          [matMenuTriggerFor]="accountMenu"
          class="tw-flex tw-items-center tw-rounded-lg tw-border-0 tw-cursor-pointer tw-transition-colors tw-text-gray-400 tw-font-semibold"
          [ngClass]="railExpanded
            ? 'tw-w-full tw-h-10 tw-justify-start tw-gap-3 tw-px-1 tw-bg-transparent hover:tw-bg-gray-800'
            : 'tw-w-9 tw-h-9 tw-justify-center tw-bg-gray-800 hover:tw-bg-gray-700'"
          matTooltip="Account"
          [matTooltipDisabled]="railExpanded"
          matTooltipPosition="left">
          <span
            *ngIf="railExpanded"
            class="tw-bg-gray-800 tw-rounded-lg tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-shrink-0">
            <span *ngIf="userInitial" class="tw-text-base">{{ userInitial }}</span>
            <mat-icon *ngIf="!userInitial" class="tw-text-gray-400">account_circle</mat-icon>
          </span>
          <ng-container *ngIf="!railExpanded">
            <span *ngIf="userInitial" class="tw-text-base">{{ userInitial }}</span>
            <mat-icon *ngIf="!userInitial" class="tw-text-gray-400">account_circle</mat-icon>
          </ng-container>
          <span *ngIf="railExpanded" class="tw-text-sm tw-text-gray-300 tw-font-normal">Account</span>
        </button>
        <mat-menu
          #accountMenu="matMenu"
          class="account-menu-popover tw-bg-gray-900 tw-text-gray-100 tw-w-80 tw-rounded-xl tw-shadow-lg tw-py-2 tw-border tw-border-solid tw-border-gray-600">
          <div class="tw-border-0 tw-border-solid tw-border-b tw-border-gray-600 tw-pb-2">
            <div class="tw-text-sm tw-font-medium tw-pl-4 tw-mb-2">
              {{ authService.getUserValue?.email }}
            </div>
            <div *ngIf="orgs.length > 1" mat-menu-item [matMenuTriggerFor]="orgsMenu">
              <div
                class="org-picker-menu-item tw-flex tw-items-center tw-gap-2 tw-mt-1 tw-cursor-pointer">
                <div
                  class="tw-bg-gray-800 tw-rounded-full tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-text-lg tw-font-bold">
                  <mat-icon class="tw-text-base tw-w-4 tw-h-5 tw-leading-5 tw-mr-0">
                    corporate_fare
                  </mat-icon>
                </div>
                <div>
                  <div class="tw-font-semibold tw-text-white tw-truncate tw-max-w-[180px]">{{ selectedOrg?.name }}</div>
                  <div
                    *ngIf="selectedOrg?.id"
                    class="tw-text-xs tw-text-gray-400 tw-flex tw-items-center tw-gap-1 tw-cursor-copy"
                    (click)="copyOrgId(selectedOrg.id, $event)">
                    <span class="font-code-pro">{{ selectedOrg.id }}</span>
                    <mat-icon class="tw-text-xs tw-w-3 tw-h-3 tw-leading-3">content_copy</mat-icon>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="orgs.length === 1"
              class="tw-flex tw-items-center tw-gap-2 tw-mt-1 tw-px-4 tw-py-2">
              <div
                class="tw-bg-gray-800 tw-rounded-full tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-text-lg tw-font-bold">
                <mat-icon class="tw-text-base tw-w-4 tw-h-5 tw-leading-5 tw-mr-0">
                  corporate_fare
                </mat-icon>
              </div>
              <div>
                <div class="tw-font-semibold tw-text-white tw-truncate tw-max-w-[180px]">{{ orgs[0].name }}</div>
                <div
                  class="tw-text-xs tw-text-gray-400 tw-flex tw-items-center tw-gap-1 tw-cursor-copy"
                  (click)="copyOrgId(orgs[0].id, $event)">
                  <span class="font-code-pro">{{ orgs[0].id }}</span>
                  <mat-icon class="tw-text-xs tw-w-3 tw-h-3 tw-leading-3">content_copy</mat-icon>
                </div>
              </div>
            </div>
          </div>
          <mat-menu
            #orgsMenu="matMenu"
            class="org-picker-menu tw-bg-gray-900 tw-text-gray-100 tw-rounded-xl tw-shadow-lg tw-border tw-border-solid tw-border-gray-600">
            <ng-container *ngFor="let org of orgs">
              <button mat-menu-item (click)="switchOrg(org.id)" class="tw-flex tw-items-center">
                <div class="tw-flex tw-items-center">
                  <mat-icon class="tw-text-base tw-mr-0">corporate_fare</mat-icon>
                  <span
                    class="tw-whitespace-nowrap tw-ellipsis tw-w-full tw-overflow-hidden tw-text-ellipsis"
                    >{{ org.name }}</span
                  >
                  <mat-icon
                    *ngIf="org.id === selectedOrg?.id"
                    class="tw-ml-2 tw-mb-1 tw-text-blue-500">
                    check
                  </mat-icon>
                </div>
              </button>
            </ng-container>
          </mat-menu>
          <button
            *ngIf="$isOrgAdmin | async"
            mat-menu-item
            [routerLink]="'/billing'"
            (click)="onNavButtonClick()">
            <span>Billing</span>
          </button>
          <button
            *ngIf="$isOrgAdmin | async"
            mat-menu-item
            [routerLink]="'/team'"
            (click)="onNavButtonClick()">
            <span>Team</span>
          </button>
          <button
            *ngIf="$isOrgAdmin | async"
            mat-menu-item
            [routerLink]="'/api-keys'"
            (click)="onNavButtonClick()">
            <span>API Keys</span>
          </button>
          <button
            *ngIf="orgs.length > 0 && ($isOrgActive | async) && selectedOrg?.id"
            mat-menu-item
            [routerLink]="'/' + selectedOrg?.id + '/integrations'"
            (click)="onNavButtonClick()">
            <span>Integrations</span>
          </button>
          <button
            *ngIf="($isOrgActive | async) && selectedOrg?.id"
            mat-menu-item
            [routerLink]="'/' + selectedOrg?.id + '/downloads'"
            (click)="onNavButtonClick()">
            <span>Downloads</span>
          </button>
          <button mat-menu-item [routerLink]="'/account'" (click)="onNavButtonClick()">
            <span>My Account</span>
          </button>
          <button
            mat-menu-item
            (click)="authService.logOut()"
            class="tw-text-red-400 tw-border-0 tw-border-solid tw-border-t tw-border-gray-600">
            <span>Log out</span>
          </button>
          <div class="tw-px-4 tw-pt-1 tw-text-xs tw-text-gray-500">Version: {{ appVersion }}</div>
        </mat-menu>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <!-- Mobile top bar: shell-owned nav opener so every routed page (current
         and future) has a way back to the rail on small screens -->
    <div
      *ngIf="isSmallScreen && !authService.palModeValue"
      class="tw-sticky tw-top-0 tw-z-10 tw-flex tw-items-center tw-gap-3 tw-bg-gray-950 tw-border-0 tw-border-b tw-border-solid tw-border-gray-700 tw-px-3 tw-py-2">
      <button
        class="toggle-sidenav-btn tw-flex tw-items-center tw-bg-gray-800 tw-p-2 tw-rounded tw-border-0 tw-cursor-pointer tw-text-white hover:tw-bg-gray-700"
        (click)="openRail()"
        aria-label="Open menu">
        <svg
          class="tw-w-5 tw-h-5"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      <img src="assets/img/logo-white.svg" alt="Live Data logo" class="tw-w-24" />
    </div>
    <div id="main-content-container">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<hotkeys-cheatsheet *ngIf="$showAdmin | async" title="Live Data admin hotkeys"></hotkeys-cheatsheet>

<app-download-status-container></app-download-status-container>
<app-streams-subscribe-drawer></app-streams-subscribe-drawer>
